<template>
  <div :name="name">
    <div v-if="isDateTimeFormat">
      <date-time v-bind="$props" :value="interval[FROM]" :name="FROM" @input="onInput"></date-time>
      <date-time v-bind="$props" :value="interval[TO]" :name="TO" @input="onInput"></date-time>
    </div>
    <date-time v-else v-bind="$props" v-on="$listeners"></date-time>
  </div>
</template>

<script>
/**
 * @param DateControl component
 *
 * @description A listák szűrésére szolgálló component
 */
import DateTime from './DateTime'

const DATE_TIME_FORMAT = ['date_interval', 'time_interval', 'datetime_interval']
const DATE_FROM = 'from'
const DATE_TO = 'to'
export default {
  name: 'DateIntervalControl',
  components: {
    DateTime,
  },
  props: ['type', 'name', 'id', 'placeholder', 'value', 'interval'],
  data() {
    return {
      intervalData: {
        interval: {
          from: '',
          to: '',
        },
      },
    }
  },
  methods: {
    onInput($event) {
      Object.assign(this.intervalData.interval, $event)
      this.$emit('input', this.intervalData)
    },
    isDateTimeFormat() {
      return DATE_TIME_FORMAT.includes(this.type)
    },
  },
  created() {
    this.FROM = DATE_FROM
    this.TO = DATE_TO
    this.DATE_TIME_FORMAT = DATE_TIME_FORMAT
    Object.assign(this.intervalData.interval, this.interval)
  },
}
</script>
